import { combineReducers } from 'redux';
import { actionTypes } from '../actions/orders';

const loading = (state = false, action) => {
    switch (action.type) {
        case actionTypes.fetchOrders:
            return true
        case actionTypes.receiveOrders:
            return false
        default:
            return state
    }
}

const list = (state = [], action) => {
    switch (action.type) {
        case actionTypes.receiveOrders:
            return action.orders
        case actionTypes.updateOrder:
            return [...state.map(order=> order.id === action.order.id ? {...order,...action.order} : order)]
        case actionTypes.clearOrders:
            return []
        default:
            return state
    }
}
export default combineReducers({ loading, list });

